import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const Content = ({ moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model }) => {
    const [{ data: conids, loading }] = useAxios({ url: `internal/cobrand/conids/false/${cobrandId ? cobrandId : ''}`, method: "get" });
    const [{ data: conidsInt, loadingInt }] = useAxios({ url: `internal/cobrand/conids/true/${cobrandId ? cobrandId : ''}`, method: "get" });
    const [{ data: videos, loadingVideos }] = useAxios({ url: `internal/cobrand/videos/false/${cobrandId ? cobrandId : ''}`, method: "get" });
    const [{ data: videosInt, loadingVideosInt }] = useAxios({ url: `internal/cobrand/videos/true/${cobrandId ? cobrandId : ''}`, method: "get" });

    return (
        <>
            <FeaturedList
                moveItem={(index, direction) => moveItem("banner1", index, direction)}
                addItem={(option) => addItem("banner1", option)}
                removeItem={(id) => removeItem("banner1", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={3}
                type="Topics Banner 1:"
                model={model.banner1}
                availableItems={conids} />

            <FeaturedList
                moveItem={(index, direction) => moveItem("banner2", index, direction)}
                addItem={(option) => addItem("banner2", option)}
                removeItem={(id) => removeItem("banner2", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={4}
                type="Topics Banner 2:"
                model={model.banner2}
                availableItems={conids} />

            <FeaturedList
                moveItem={(index, direction) => moveItem("banner3", index, direction)}
                addItem={(option) => addItem("banner3", option)}
                removeItem={(id) => removeItem("banner3", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={5}
                type="Topics Banner 3:"
                model={model.banner3}
                availableItems={conids} />

            <FeaturedList
                moveItem={(index, direction) => moveItem("videos", index, direction)}
                addItem={(option) => addItem("videos", option)}
                removeItem={(id) => removeItem("videos", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={6}
                type="Videos"
                model={model.videos}
                availableItems={videos} />

            <FeaturedList
                moveItem={(index, direction) => moveItem("videosInternational", index, direction)}
                addItem={(option) => addItem("videosInternational", option)}
                removeItem={(id) => removeItem("videosInternational", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={6}
                type="Videos (International):"
                model={model.videosInternational}
                availableItems={videosInt} />

            <FeaturedList
                moveItem={(index, direction) => moveItem("search", index, direction)}
                addItem={(option) => addItem("search", option)}
                removeItem={(id) => removeItem("search", id)}
                saveIndividual={saveIndividual}
                showUpdateBtn={showUpdateBtn}
                typeId={7}
                type="Search:"
                model={model.search}
                availableItems={conids} />
        </>
    );
};

export default Content;
